import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { Link } from 'react-router-dom'

const INIT = {
    name: '',
    description: '',
    created_by: '',
    slug: '',
    active: true,
    category_id: null,
}
const ProductTypesEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [currentCategory, setCurrentCategory] = React.useState(null)
    const disabled = !data.name || !data.description

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const getData = () => {
        setloading(true)
        API.get(`/api/subcategories/${match.params.id}`)
            .then(response => {
                setloading(false)
                setData(response.data)
                if (response.data.category) {
                    setCurrentCategory(response.data.category.name)
                }
            })
            .catch(() => {
                setloading(false)
            })
    }
    React.useEffect(() => {
        getData()
    }, [])

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.patch(`/api/subcategories/${match.params.id}`, data)
            .then(() => {
                setloading(false)
                notification.success({
                    message: 'La subcategoría se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear tipo de producto</Divider>
            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">

                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser llenados.

                </p>
                <Form.Item label="Nombre" hasFeedback>
                    <Input
                        placeholder="Escribe el nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Descripción" hasFeedback>
                    <Input
                        placeholder="Escribe la descripción"
                        value={data.description}
                        onChange={e => {
                            handleChange('description', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Categoría">
                    <Search
                        value={currentCategory}
                        placeholder="Busca una categoría"
                        onSearch={value => `/api/categories?filter[name]=${value}&filter[active]=1`}
                        onChange={(key, value) => {
                            handleChange('category_id', key)
                            setCurrentCategory(value.name)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/subcategories">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default ProductTypesEditContainer
